// import HeaderSubMenu from './submenu/HeaderSubMenu';
import HeaderSubMenuPublic from './submenu/HeaderSubMenuPublic';
import React from 'react';
import Tippy from '@tippyjs/react/headless';
import GuestSignInLogo from './GuestSignInLogo';

const ProfileMenu = () => (
  <Tippy
    interactive={true}
    trigger='click'
    placement='bottom-end'
    render={(attrs) => (
      <div className='box' tabIndex='-1' {...attrs}>
        <HeaderSubMenuPublic />
      </div>
    )}>
    <div className='profile-menu-public'>
      <GuestSignInLogo fillColor={'var(--bg-skyblue)'} />
    </div>
  </Tippy>
);

export default ProfileMenu;
